import httpClient from "../config/httpClient";

export abstract class NumberPoolService {
	private static readonly BASE_URL = "/sys03/number-pool";

	public static fetchProvinceAvailableNumbers(province: string) {
		const url = `${NumberPoolService.BASE_URL}/available/${province}`;
		return httpClient.get<string[]>(url).then((response) => response.data);
	}

	public static reserveNumber(number: string) {
		const url = `${NumberPoolService.BASE_URL}/reserve/${number}`;
		return httpClient.put<void>(url);
	}
}
